/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';
import {InfoIcon} from "../../InfoIcon";
import {HelpIcon} from "../../HelpIcon";
import {SurveyFormInput} from "../SurveyFormInput";
import {service as SurveyQuestionDataTypeService} from "../../../../Services/SurveyQuestionDataTypeService";
import {usePrimeCache} from "../../../../Hooks/ServiceHooks";

export const SurveyFormQuestion = (props) => {
    
    const {
        conservationAction,
        surveyTypeId, // required for the old SurveyFormInputFile to default Tags
        question,
        
        editMode,
        
        getQuestionAnswer = ((q) => {}),
        getQuestionValidation = ((q) => {}),
        
        /* Handlers */
        OnAnswerChange,
        OnConservationActionChange,
        OnValidation,
        // DeleteAnswer, // not used anymore? 
        // OnCustomDataChange, // only used by Custom Sections
        // OnFinish, // only use by Sections
        // OnSave, // only use by Sections
        
        
        ...remaining
    } = props;
    
    usePrimeCache([SurveyQuestionDataTypeService])
    
    const isLabel = (id) => {
        const label = SurveyQuestionDataTypeService.CachedValueByProperty('label', 'code');
        
        if (!label) {
            return false;
        }
        
        return id === label.surveyQuestionDataTypeId;
    }
    
    const labelClass = isLabel(question.surveyQuestionDataTypeId) ? 'sb-survey-label' : '';

    const questionName = <>
        {question.name}
        {question.isRequired && <span className="sb-required-indicator"> *</span>}
    </>;

    let label = <span className={labelClass}>
        {questionName}
        <InfoIcon link={question.infoLink}>
            {question.infoTitle}
        </InfoIcon>
    </span>;

    if (question.helpText) {
        label = <span className={labelClass}>{questionName}
            <HelpIcon placement="right" id={"survey-question-tooltip-" + question.surveyQuestionId}>
                {question.helpText}
            </HelpIcon>
            <InfoIcon link={question.infoLink}>
                {question.infoTitle}
            </InfoIcon>
        </span>
    }

    const description = question?.PermitType?.description ?? question.description ?? null;

    return <tr key={question.surveyQuestionId}>
        <td>
            {label}
            {description &&
                <p className="description">{description}</p>}
        </td>
        <td>
            <SurveyFormInput
                SurveyTypeId={surveyTypeId}
                ConservationAction={conservationAction}
                Question={question}
                Validation={getQuestionValidation(question)}
                Answer={getQuestionAnswer(question)}
                OnChange={OnAnswerChange}
                OnConservationActionChange={OnConservationActionChange}
                OnValidation={OnValidation}
                EditMode={question?.isReadOnly ? false : editMode}
            />
        </td>
    </tr>;
}

export default SurveyFormQuestion;
